export enum COOPERATION_FORMS {
  COMPANY = 'COMPANY',
  SOLE_PROPRIETORSHIP = 'SOLE_PROPRIETORSHIP',
  INDIVIDUAL = 'INDIVIDUAL',
}
